import Featured from './Featured';

export default Featured;


// WEBPACK FOOTER //
// ./src/components/Featured/index.tsx